import { Sparkles } from "lucide-react";

const lineItems = [
  { label: "Material", value: 18400 },
  { label: "Machine hours", value: 32000 },
  { label: "Labour", value: 8600 },
  { label: "Overheads", value: 4200 },
];

export default function CostEstimator() {
  const total = lineItems.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="rounded-xl border bg-card text-card-foreground shadow p-5 h-fit">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shrink-0">
          <Sparkles className="w-5 h-5 text-white" />
        </div>
        <div>
          <p className="font-bold text-gray-900">AI Cost Estimator</p>
          <p className="text-xs text-gray-500">Live estimate as you fill</p>
        </div>
      </div>

      <div className="space-y-3 mb-4">
        {lineItems.map(({ label, value }) => (
          <div key={label} className="flex items-center justify-between text-sm">
            <span className="text-gray-600">{label}</span>
            <span className="font-semibold text-gray-900">
              ₹{value.toLocaleString("en-IN")}
            </span>
          </div>
        ))}
      </div>

      <div className="border-t border-gray-100 pt-4 mb-4">
        <div className="flex items-center justify-between mb-1">
          <span className="font-bold text-gray-900">Estimated Total</span>
          <span className="font-extrabold text-indigo-600 text-lg">
            ₹{total.toLocaleString("en-IN")}
          </span>
        </div>
        <p className="text-xs text-gray-500">Estimated delivery: 12–14 days</p>
      </div>

      <span className="inline-flex items-center gap-1.5 text-xs font-semibold bg-indigo-50 text-indigo-600 px-3 py-1.5 rounded-full">
        <Sparkles className="w-3 h-3" /> Powered by AI
      </span>
    </div>
  );
}